import WebFont from 'webfontloader'
import bus from './bus'

WebFont.load({
  custom: {
    families: ['Ciutadella:4n,6n', 'Ciutadella Slab:4n,5n', 'Americane:4n']
  },
  active: _ => bus.emit('fonts-loaded')
})
